export const GET_DOCUMENTS_PENDING = '[DOCUMENTS][GET] get Cases pending';
export const GET_DOCUMENTS_SUCCESS = '[DOCUMENTS][GET] get Cases success';
export const GET_LINKEDCASE_SUCCESS = '[DOCUMENTS][GET] get LinkedCase success';
export const GET_DOCUMENTS_FAILURE = '[DOCUMENTS][GET] get Cases failure';
export const SHOW_FILTER_MODAL = '[DOCUMENTS][FILTERS] toggle Modal';
export const HYDRATE_DOCUMENTS_FILTERS = '[DOCUMENTS][FILTERS] hydrate filters';
export const GET_CLIENTS_SUCCESS = '[DOCUMENTS][UPLOAD] get clients';
export const GET_DOCUMENT_TYPES_SUCCESS = '[DOCUMENTS][UPLOAD] get document types';
export const SET_DOCUMENT_ID = '[DOCUMENTS][UPLOAD] set document id';
export const RESET_DOCUMENT_UPLOAD = '[DOCUMENTS][UPLOAD] reset document upload';
export const RESET_DOCUMENT_FIELDS = '[DOCUMENTS][UPLOAD] reset document upload fields';
export const GET_EMPLOYEES_SUCCESS = '[DOCUMENTS][UPLOAD] get employees';
export const GET_DOCUMENT_FIELDS_SUCCESS = '[DOCUMENTS][UPLOAD] get document fields';
export const SAVE_DOCUMENT_SUCCESS = '[DOCUMENTS][UPLOAD] save document';
export const OPEN_DOCUMENTS_SUCCESS = '[DOCUMENTS][POST] open Documents success';
export const DELETE_DOCUMENTS_SUCCESS = '[DOCUMENTS][POST] delete Documents success';
export const GO_TO_DETAILS = '[DOCUMENTS][NAV] to go Document Details';
export const HYDRATE_DOCUMENT_DETAILS = '[DOCUMENTS][DETAILS] hydrate details';
export const DEHYDRATE_DOCUMENT_DETAILS = '[DOCUMENTS][DETAILS] dehydrate details';
export const HYDRATE_DOCUMENTS = '[DOCUMENTS][HYDRATE] hydrate documents';
export const SHOW_DELETE_NOTIFICATION_SUCCESS = '[DOCUMENTS][SHOW] show notification success';
export const HIDE_DELETE_NOTIFICATION_SUCCESS = '[DOCUMENTS][HIDE] hide notification success';
export const REFRESH_DOCUMENT_STATE = '[DOCUMENTS][REFRESH] refresh docs';
export const APPLIED_DOCUMENTS_FILTERS = '[DOCUMENTS][APPLIED][FILTERS] applied filters pagination';
export const STORE_CASEMANAGER_ID = '[DOCUMENTS][STORE][ID] stored caseManagerId';
export const OPEN_DOCS_TAB = '[DOCUMENTS][OPEN][TAB] open docs tab';
export const INCREMENT_DOC_COUNT = '[DOCUMENTS][INCREMENT][COUNT] increment document count';
export const MARK_DOCUMENT_READ = '[CASES][DOCUMENTS][MARK] mark as read';
export const GET_SUPPORT_FILE= 'Supported file gets successful';
export const GET_IR_COUNTER= 'IR Counter value getting successfully';
export const GET_IR_COUNTER_FAILURE='IR Counter value failed';
export const GET_SLA_DOCUMENT_DETAILS = '[DOCUMENTS][DETAILS] sla details';
export const GET_SLA_LIST = '[DOCUMENTS][DETAILS] sla list'
export const ZIP_DOCUMENTS_SUCCESS = 'Zip Download Success';
export const EXECUTE_SP_API_SUCCESS = 'Executed SP API Successfully'
export const GET_REJECTED_FILE_FAILURE = "Rejjected file";
export const RESET_DELETEDFILE = "File deleted";
export const DISABLE_SERVICE_SPINNER = 'DISABLE_UPLOAD_SERVICE_SPINNER';
export const ENABLE_SERVICE_SPINNER = 'ENABLE_UPLOAD_SERVICE_SPINNER';
export const ENABLE_DOC_SUBMIT_SERVICE_SPINNER = 'ENABLE_SUBMIT_SERVICE_SPINNER';
export const DISABLE_DOC_SUBMIT_SERVICE_SPINNER = 'DISABLE_SUBMIT_SERVICE_SPINNER';
export const DELETE_UPLOADED_DOCUMENT = "Delete Upload document";
export const ACKNOWLEDGE_DOCUMENT_READ = '[CASES][DOCUMENTS][ACKNOWLEDGE]  as read';
export const UPDATE_UPLOAD_STATUS = '[CASES][DOCUMENTS][UPLOADSTATUS] mark as read';



// WEBPACK FOOTER //
// ./src/ui/features/Documents/state/documentsTypes.js